import Error404 from "../components/atoms/Error404";

const NotFound = () => {
    return(
        <>
            <div>
                <Error404/>
            </div>
        </>
    );
}

export default NotFound;